import React from 'react';
import { Button, Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { PageSectionTitle } from 'src/components/enterprise/layout/PageSectionTitle/PageSectionTitle';
import { useCreateReport } from 'src/components/enterprise/features/Reporting/CreateReportsPage/hooks/useCreateReport';
import { DinerEmailFilterControl } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/DinerEmailFilterControl/DinerEmailFilterControl';
import { ReportNameControl } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/ReportNameControl/ReportNameControl';
import { DateRangePicker } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/DateRangePicker/DateRangePicker';
import { LocationsSelectControl } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/LocationsSelectControl/LocationsSelectControl';
import { transformCreateReportFormToPayload } from 'src/components/enterprise/features/Reporting/CreateReportsPage/utils/CreateReportsPage.utils';
import { CreateReportFormFields } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/CreateReportForm/CreateReportFormProvider';

const UNIQUE_REPORT_NAME = 'corporate-detailed-history';

export const CreateReportForm: React.FC = () => {
  const { corpId } = useAuth();
  const {
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useFormContext<CreateReportFormFields>();

  const { submitCreateReport } = useCreateReport({ corpId });

  const onSubmit = handleSubmit((values) =>
    submitCreateReport(
      transformCreateReportFormToPayload(values, UNIQUE_REPORT_NAME)
    )
  );

  return (
    <>
      <Stack y="md">
        <PageSection>
          <Stack y="sm">
            <PageSectionTitle title="Report Information" />
          </Stack>
          <Stack y="sm">
            <Row gutter={12}>
              <Column phone={12} tablet={8} desktop={5} gutter={12}>
                <ReportNameControl name="reportName" id="reportName" />
              </Column>
            </Row>
          </Stack>
          <Stack y="sm">
            <Row gutter={12}>
              <Column phone={12} tablet={8} desktop={5} gutter={12}>
                <DateRangePicker />
              </Column>
            </Row>
          </Stack>
          <Stack y="sm">
            <Row gutter={12}>
              <Column phone={12} tablet={8} desktop={5} gutter={12}>
                <LocationsSelectControl name="locations" />
              </Column>
            </Row>
          </Stack>
          <Stack y="sm">
            <Row gutter={12}>
              <Column phone={12} tablet={8} desktop={5} gutter={12}>
                <DinerEmailFilterControl
                  name="employeeEmail"
                  id="employeeEmail"
                />
              </Column>
            </Row>
          </Stack>
        </PageSection>
      </Stack>
      <Stack y="lg">
        <Row gutter={8}>
          <Column gutter={8} phone={3}>
            <Button
              type="button"
              variant="primary"
              buttonSize="medium"
              block
              disabled={!isValid || isSubmitting}
              isLoading={isSubmitting}
              onClick={onSubmit}
            >
              Create Report
            </Button>
          </Column>
        </Row>
      </Stack>
    </>
  );
};
